module.exports = __webpack_public_path__ + "img/addition.c3c72227.jpg";